window.jQuery = $;

import 'intl-tel-input';


import '../scripts/vendor/jquery-jasny-inputmask-3.1.0';
import '../scripts/vendor/jquery-maskedinput-1.4.1';
import '../scripts/vendor/jquery-putcursoratend';
import '../scripts/vendor/jquery-scrollto-2.1.2';
import '../scripts/vendor/jquery-visibility-1.0.12';
import './spin/spin.jquery';

import './jquery-plugins/dl-menu-1.0.1.modified'
import './jquery-plugins/easing-ease-out-expo'
import './jquery-plugins/skip-to-content'


$.ajaxSetup( {
	xhrFields  : {
		withCredentials: true
	},
	crossDomain: true,	
} );
